import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-[4px] bg-red-100 p-[8px] rounded-[2px] flex items-center gap-[8px] z-[1] mb-[16px]"
}
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "flex-shrink-0" }
const _hoisted_4 = { class: "ml-3" }
const _hoisted_5 = { class: "text-12 font-medium text-red-400" }
const _hoisted_6 = {
  key: 0,
  class: "text-12 font-medium text-red-400"
}
const _hoisted_7 = {
  role: "list",
  class: "pl-5 space-y-1 list-disc"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "top-fade" }, {
    default: _withCtx(() => [
      ($props.data)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode($setup["XCircleIcon"], {
                  class: "h-[16px] text-red-400",
                  "aria-hidden": "true"
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h3", _hoisted_5, _toDisplayString($setup.grouped_message), 1 /* TEXT */),
                ($props.data.errors.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("ul", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.errors, (e) => {
                          return (_openBlock(), _createElementBlock("li", null, _toDisplayString(e.message), 1 /* TEXT */))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}